// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.CustomColumnChart_scroll__f9HS7::-webkit-scrollbar {
  height: 8px;
}
.CustomColumnChart_scroll__f9HS7::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.CustomColumnChart_scroll__f9HS7::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.CustomColumnChart_CustomColumnChart__9EZjm {
  background-color: var(--bgColor);
  padding: 20px;
  padding-bottom: 0;
  min-height: 272px;
  position: relative;
}
.CustomColumnChart_CustomColumnChart__9EZjm .CustomColumnChart_Actions__WyQ98 {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.CustomColumnChart_CustomColumnChart__9EZjm .CustomColumnChart_Actions__WyQ98 .CustomColumnChart_ActionBtn__dUhED {
  flex-shrink: 0;
  position: relative;
  font-size: 0;
}
.CustomColumnChart_CustomColumnChart__9EZjm .CustomColumnChart_Actions__WyQ98 .CustomColumnChart_ActionBtn__dUhED:not(:last-child) {
  -webkit-padding-end: 10px;
          padding-inline-end: 10px;
  -webkit-border-end: 1px solid var(--borderColor);
          border-inline-end: 1px solid var(--borderColor);
}
.CustomColumnChart_CustomColumnChart__9EZjm .CustomColumnChart_toolBar__h6DdF {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  width: 100%;
}
.CustomColumnChart_CustomColumnChart__9EZjm .CustomColumnChart_toolBar__h6DdF .CustomColumnChart_Filters__u-ytO {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  flex-wrap: wrap;
  max-width: 90%;
}
.CustomColumnChart_CustomColumnChart__9EZjm .CustomColumnChart_toolBar__h6DdF .CustomColumnChart_Filters__u-ytO .CustomColumnChart_Select__sH0Ok {
  width: 140px;
}
.CustomColumnChart_CustomColumnChart__9EZjm .CustomColumnChart_toolBar__h6DdF .CustomColumnChart_Filters__u-ytO .CustomColumnChart_Select__sH0Ok:not(:last-child) {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.CustomColumnChart_CustomColumnChart__9EZjm .apexcharts-legend-marker {
  border-radius: 0 !important;
  margin-right: 0;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
}
.CustomColumnChart_CustomColumnChart__9EZjm .apexcharts-tooltip {
  padding: 20px;
  min-width: 178px;
  background-color: var(--bgColor);
  border-radius: 0;
  border: 1px solid var(--borderColor);
}
.CustomColumnChart_CustomColumnChart__9EZjm .apexcharts-tooltip p {
  font-size: 12px !important;
  text-transform: uppercase;
}
body[dir=ltr] .CustomColumnChart_CustomColumnChart__9EZjm .apexcharts-tooltip p strong {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .CustomColumnChart_CustomColumnChart__9EZjm .apexcharts-tooltip p strong {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.CustomColumnChart_CustomColumnChart__9EZjm .mentions_tooltip {
  text-align: center;
  width: auto;
}
.CustomColumnChart_CustomColumnChart__9EZjm .searchCountTooltip {
  text-align: start;
}
.CustomColumnChart_CustomColumnChart__9EZjm .searchCountTooltip h3 {
  margin-bottom: 10px;
}
.CustomColumnChart_CustomColumnChart__9EZjm .searchCountTooltip h3,
.CustomColumnChart_CustomColumnChart__9EZjm .searchCountTooltip p {
  font-size: 10px !important;
  font-family: "LatoRegular", "CairoRegular", sans-serif;
  color: var(--mainColor);
}
.CustomColumnChart_CustomColumnChart__9EZjm .categoryNamesTooltip div {
  font-size: 0;
}
.CustomColumnChart_CustomColumnChart__9EZjm .categoryNamesTooltip h3,
.CustomColumnChart_CustomColumnChart__9EZjm .categoryNamesTooltip p {
  margin-bottom: 10px;
  font-size: 10px;
  font-family: "LatoRegular", "CairoRegular", sans-serif;
  color: var(--mainColor);
}
.CustomColumnChart_CustomColumnChart__9EZjm .categoryNamesTooltip h3:last-child,
.CustomColumnChart_CustomColumnChart__9EZjm .categoryNamesTooltip p:last-child {
  margin-bottom: 0;
}
.CustomColumnChart_CustomColumnChart__9EZjm .trending_compare {
  margin-top: 10px;
  min-width: 250px;
}
.CustomColumnChart_CustomColumnChart__9EZjm .trending_compare h6 {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  text-transform: uppercase;
}
.CustomColumnChart_CustomColumnChart__9EZjm .arrow_box {
  display: flex;
  justify-content: space-between;
}
.CustomColumnChart_CustomColumnChart__9EZjm .arrow_box .subCategory {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.CustomColumnChart_CustomColumnChart__9EZjm .arrow_box .head_title {
  margin: 10px 0;
  font-size: 12px;
  text-transform: uppercase;
}
.CustomColumnChart_CustomColumnChart__9EZjm .arrow_box > div h6 {
  font-size: 12px !important;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.CustomColumnChart_CustomColumnChart__9EZjm .arrow_box > div > div div {
  font-size: 10px !important;
  margin-bottom: 10px;
  max-width: 155px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.2;
}
.CustomColumnChart_CustomColumnChart__9EZjm .user_tooltip .title {
  font-weight: bold;
  margin-bottom: 10px;
  text-transform: capitalize;
}
.CustomColumnChart_CustomColumnChart__9EZjm .user_tooltip .user_info {
  display: flex;
  align-items: center;
}
.CustomColumnChart_CustomColumnChart__9EZjm .user_tooltip .user_info:not(:last-child) {
  border-bottom: 1px solid var(--borderColor);
  margin-bottom: 10px;
  padding-bottom: 10px;
}
.CustomColumnChart_CustomColumnChart__9EZjm .user_tooltip .user_info .user_image {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  overflow: hidden;
  border: 1px solid var(--secondaryColor);
}
.CustomColumnChart_CustomColumnChart__9EZjm .user_tooltip .user_info .user_image.defaultImg {
  border: none;
}
.CustomColumnChart_CustomColumnChart__9EZjm .user_tooltip .user_info .user_image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.CustomColumnChart_CustomColumnChart__9EZjm .user_tooltip .user_info .user_image svg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.CustomColumnChart_CustomColumnChart__9EZjm .user_tooltip a {
  text-align: center;
  margin: auto;
  display: block;
  width: 100%;
  font-weight: bold;
}
body[dir=rtl] .CustomColumnChart_CustomColumnChart__9EZjm .apexcharts-xaxis text {
  direction: ltr;
}
.CustomColumnChart_CustomColumnChart__9EZjm .apexcharts-tooltip.apexcharts-theme-light {
  background-color: var(--bgColor);
  border: var(--borderColor);
}

.CustomColumnChart_specityChartHolder__z8tnK {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  top: 58px;
  /* body[dir= ltr ] & {
    left: 50%;
    transform: translateX(-60%);
  }
  body[dir= rtl ] & {
    right: 50%;
    transform: translateX(60%);
  }
  @include Sm {
    body[dir= ltr ] & {
      padding-left: 0;
    }
    body[dir= rtl ] & {
      padding-right: 0;
    }
  }*/
}
@media (max-width: 992px) {
  .CustomColumnChart_specityChartHolder__z8tnK {
    gap: 5px;
  }
}

.CustomColumnChart_specifyChart__lS7ki {
  display: flex;
  align-items: center;
}

.CustomColumnChart_colorBox__HQYMy {
  min-width: 12px;
  height: 12px;
  -webkit-margin-end: 4px;
          margin-inline-end: 4px;
  border: 1px solid;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Charts/CustomColumnChart/CustomColumnChart.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,gCAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAsDF;AApDE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAsDJ;AApDI;EACE,cAAA;EACA,kBAAA;EACA,YAAA;AAsDN;AApDM;EACE,yBAAA;UAAA,wBAAA;EACA,gDAAA;UAAA,+CAAA;AAsDR;AAjDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;AAmDJ;AAlDI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAoDN;AAlDM;EACE,YAAA;AAoDR;AAlDQ;EACE,wBAAA;UAAA,uBAAA;AAoDV;AA9CI;EACE,2BAAA;EACA,eAAA;EACA,uBAAA;UAAA,sBAAA;AAgDN;AA9CI;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,oCAAA;AAgDN;AA/CM;ED8CF,0BAAA;EC5CI,yBAAA;AAiDR;AA/CU;EACE,2DAAA;AAiDZ;AA/CU;EACE,2DAAA;AAiDZ;AA5CI;EACE,kBAAA;EACA,WAAA;AA8CN;AA5CI;EACE,iBAAA;AA8CN;AA7CM;EACE,mBAAA;AA+CR;AA7CM;;EAEE,0BAAA;EACA,sDD9BM;EC+BN,uBAAA;AA+CR;AA3CM;EACE,YAAA;AA6CR;AA3CM;;EAEE,mBAAA;EACA,eAAA;EACA,sDD1CM;EC2CN,uBAAA;AA6CR;AA3CQ;;EACE,gBAAA;AA8CV;AA1CI;EACE,gBAAA;EACA,gBAAA;AA4CN;AA1CM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;AA4CR;AAzCI;EACE,aAAA;EAEA,8BAAA;AA0CN;AAxCM;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AA0CR;AAxCM;EACE,cAAA;EACA,eAAA;EACA,yBAAA;AA0CR;AAvCM;ED5BF,0BAAA;EC8BI,mBAAA;EACA,yBAAA;AAyCR;AAtCM;EDpCF,0BAAA;ECsCI,mBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AAuCR;AAnCM;EACE,iBAAA;EACA,mBAAA;EACA,0BAAA;AAqCR;AAnCM;EACE,aAAA;EACA,mBAAA;AAqCR;AApCQ;EACE,2CAAA;EACA,mBAAA;EACA,oBAAA;AAsCV;AApCQ;EACE,wBAAA;UAAA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;AAsCV;AArCU;EACE,YAAA;AAuCZ;AArCU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAuCZ;AArCU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAuCZ;AAnCM;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AAqCR;AAjCM;EACE,cAAA;AAmCR;AAhCI;EACE,gCAAA;EACA,0BAAA;AAkCN;;AA9BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EAKA;;;;;;;;;;;;;;;IAAA;AA4CF;AD3GE;ECqDF;IAOI,QAAA;EAmDF;AACF;;AAhCA;EACE,aAAA;EACA,mBAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,YAAA;EACA,uBAAA;UAAA,sBAAA;EACA,iBAAA;AAmCF","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.CustomColumnChart {\n  background-color: var(--bgColor);\n  padding: 20px;\n  padding-bottom: 0;\n  min-height: 272px;\n  position: relative;\n\n  .Actions {\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    .ActionBtn {\n      flex-shrink: 0;\n      position: relative;\n      font-size: 0;\n\n      &:not(:last-child) {\n        padding-inline-end: 10px;\n        border-inline-end: 1px solid var(--borderColor);\n      }\n    }\n  }\n\n  .toolBar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 30px;\n    width: 100%;\n    .Filters {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      flex-shrink: 0;\n      flex-wrap: wrap;\n      max-width: 90%;\n\n      .Select {\n        width: 140px;\n\n        &:not(:last-child) {\n          margin-inline-end: 10px;\n        }\n      }\n    }\n  }\n  :global {\n    .apexcharts-legend-marker {\n      border-radius: 0 !important;\n      margin-right: 0;\n      margin-inline-end: 4px;\n    }\n    .apexcharts-tooltip {\n      padding: 20px;\n      min-width: 178px;\n      background-color: var(--bgColor);\n      border-radius: 0;\n      border: 1px solid var(--borderColor);\n      p {\n        @include fontSize(12);\n        text-transform: uppercase;\n        strong {\n          #{$ltr} & {\n            font-family: $latoBold !important;\n          }\n          #{$rtl} & {\n            font-family: $CairoBold !important;\n          }\n        }\n      }\n    }\n    .mentions_tooltip {\n      text-align: center;\n      width: auto;\n    }\n    .searchCountTooltip {\n      text-align: start;\n      h3 {\n        margin-bottom: 10px;\n      }\n      h3,\n      p {\n        font-size: 10px !important;\n        font-family: $latoRegular;\n        color: var(--mainColor);\n      }\n    }\n    .categoryNamesTooltip {\n      div {\n        font-size: 0; // this is for the unwanted \"comma\" after category names\n      }\n      h3,\n      p {\n        margin-bottom: 10px;\n        font-size: 10px;\n        font-family: $latoRegular;\n        color: var(--mainColor);\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n    .trending_compare {\n      margin-top: 10px;\n      min-width: 250px;\n\n      h6 {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        font-size: 12px;\n        text-transform: uppercase;\n      }\n    }\n    .arrow_box {\n      display: flex;\n      // align-items: center;\n      justify-content: space-between;\n      // padding: 0 20px;\n      .subCategory {\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: flex-start;\n      }\n      .head_title {\n        margin: 10px 0;\n        font-size: 12px;\n        text-transform: uppercase;\n      }\n\n      & > div h6 {\n        @include fontSize(12);\n        margin-bottom: 10px;\n        text-transform: uppercase;\n      }\n\n      & > div > div div {\n        @include fontSize(10);\n        margin-bottom: 10px;\n        // white-space: normal;\n        max-width: 155px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        line-height: 1.2;\n      }\n    }\n    .user_tooltip {\n      .title {\n        font-weight: bold;\n        margin-bottom: 10px;\n        text-transform: capitalize;\n      }\n      .user_info {\n        display: flex;\n        align-items: center;\n        &:not(:last-child) {\n          border-bottom: 1px solid var(--borderColor);\n          margin-bottom: 10px;\n          padding-bottom: 10px;\n        }\n        .user_image {\n          margin-inline-end: 10px;\n          width: 30px;\n          height: 30px;\n          border-radius: 100%;\n          overflow: hidden;\n          border: 1px solid var(--secondaryColor);\n          &.defaultImg {\n            border: none;\n          }\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n          svg {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n        }\n      }\n      a {\n        text-align: center;\n        margin: auto;\n        display: block;\n        width: 100%;\n        font-weight: bold;\n      }\n    }\n    .apexcharts-xaxis text {\n      #{$rtl} & {\n        direction: ltr;\n      }\n    }\n    .apexcharts-tooltip.apexcharts-theme-light {\n      background-color: var(--bgColor);\n      border: var(--borderColor);\n    }\n  }\n}\n.specityChartHolder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n  top: 58px;\n  @include Sm {\n    gap: 5px;\n  }\n  // position: absolute;\n  /* #{$ltr} & {\n    left: 50%;\n    transform: translateX(-60%);\n  }\n  #{$rtl} & {\n    right: 50%;\n    transform: translateX(60%);\n  }\n  @include Sm {\n    #{$ltr} & {\n      padding-left: 0;\n    }\n    #{$rtl} & {\n      padding-right: 0;\n    }\n  }*/\n}\n.specifyChart {\n  display: flex;\n  align-items: center;\n}\n\n.colorBox {\n  min-width: 12px;\n  height: 12px;\n  margin-inline-end: 4px;\n  border: 1px solid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `CustomColumnChart_scroll__f9HS7`,
	"CustomColumnChart": `CustomColumnChart_CustomColumnChart__9EZjm`,
	"Actions": `CustomColumnChart_Actions__WyQ98`,
	"ActionBtn": `CustomColumnChart_ActionBtn__dUhED`,
	"toolBar": `CustomColumnChart_toolBar__h6DdF`,
	"Filters": `CustomColumnChart_Filters__u-ytO`,
	"Select": `CustomColumnChart_Select__sH0Ok`,
	"specityChartHolder": `CustomColumnChart_specityChartHolder__z8tnK`,
	"specifyChart": `CustomColumnChart_specifyChart__lS7ki`,
	"colorBox": `CustomColumnChart_colorBox__HQYMy`
};
export default ___CSS_LOADER_EXPORT___;
